// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"222":"93385089","302":"803d66c9","369":"790ff192","389":"92b5e8ca"}[chunkId] + ".chunk.js";
};